module.exports = __webpack_public_path__ + "img/ynjt1.f4d6dcf3.jpg";